module.exports = __webpack_public_path__ + "img/icon_videoCall@2x.0925a930.png";